// extracted by mini-css-extract-plugin
export default {"container":"VBSpinnerButton_container__oJb4w"};